import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { Controller } from "react-hook-form"
import { withTranslation } from 'react-i18next'
import Checkbox from '@mui/material/Checkbox'
import { FormControlLabel } from '@mui/material'

const Input = (props) => {
  const { name, label } = props

  const { control, watch, trigger } = useFormContext()
  let v = watch(name)

  useEffect(() => {
    if (v) trigger(name)
  }, [v, trigger, name])


  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
        <FormControlLabel
          control={
            <Checkbox
              defaultChecked={false}
              onChange={onChange}
              name={name}
              color="primary"
            />
          }
          label={label}
        />
      )}
    />
  )
}

export default withTranslation()(Input)